import React from 'react'
import PropTypes from 'prop-types'

import ErrorComponent from 'components/Errors/ErrorComponent'

const HeaderAppError = ({ appError, defaultContent }) => {
    return (
        <>
            <ErrorComponent error={appError} />
            {defaultContent}
        </>
    )
}

export default HeaderAppError

HeaderAppError.propTypes = {
    appError: PropTypes.object.isRequired,
    defaultContent: PropTypes.node.isRequired,
}
